<app-progress-spinner *ngIf="!showGrid || submitted"></app-progress-spinner>
<div class="container">


  <div class="col-md-12 col-lg-12 label-header" style="height: 34.66px;">
    <label class="label-headercolor label-text">Define Reference configuration and weight </label>
  </div>
  <div class="row">
    <div class="col-md-6" style="padding-left: 15px; padding-top: 25px; height:66vh;">
      <div class="configuration-vblo-header label-header"
        style="border-radius: 3px; position: sticky; top: 0px; z-index: 1;">
        <label class="label-headercolor" style="padding: 8px;">Select a KMAT</label>
      </div>
      <!-- <label class="label-headercolor label-text" style="padding-bottom: 0 !important;">Select a KMAT</label> -->
      <div class="search-container">
        <div class="js-textfield textfield-with-prefix grid-search-bar"
          style="border-radius: 5px; border: 1px solid #6666666e; margin: 5px; ">
          <input id="inputBox" placeholder="Search for KMAT" aria-label="Search"
            class="form-control textfield__input borderStyle" style="padding: 0 10px !important; font-size: 0.9rem;"
            (input)="filterKMAT($event.target.value)" />
        </div>
      </div>


      <ag-grid-angular id="kmatGrid" [rowClassRules]="rowClassRules" rowSelection="multiple"
        style="width: 100%; height:82.3%" class="ag-theme-alpine  p-treenode-selectable" [rowData]="allKmatData"
        [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
        (gridSizeChanged)="onGridSizeChanged($event)" (rowClicked)="onKmatSelected($event)"
        [enableBrowserTooltips]="true" (displayedColumnsChanged)="onDisplayedColumnsChanged">
      </ag-grid-angular>
    </div>
    <div class="col-md-6" style="padding-left: 15px; padding-top: 25px; height:66vh;">
      <div class="configuration-vblo-header label-header"
        style="border-radius: 3px; position: sticky; top: 0px; z-index: 1;">
        <label class="label-headercolor" style="padding-bottom: 0px">Selection
          <button (click)="addNewConfiguration()" aria-label="Add">
            <img alt="Plus Icon" src="../assets/icons/Plus.svg" width="25" height="25" />
          </button>
          to create new VBLO manually </label>
      </div>
      <p-tree #vbloTree  [value]="kmatVbloMaterialData" [(selection)]="selectedNodes" selectionMode="checkbox"
        [filter]="true" (selectionChange)="onTreeSelectionChange($event)"
        (onNodeSelect)="onNodeToggle($event.node, true)" (onNodeUnselect)="onNodeToggle($event.node, false)"
        scrollHeight="50vh">
        <!-- <ng-template let-node pTemplate="default">
           <span class="tree-label">{{ node.key }}</span>
          
        </ng-template> -->
      </p-tree>
    </div>
  </div>
  <div class="row" style="height: 65px; margin-top: 10px;">
    <div class="offset-6 col-md-6">
      <div class="buttonStyle" style="float: right; margin-right: 5px;">
        <button class="button button--small" (click)="onClickCancel()">
          Cancel & Exit</button>&nbsp;
        <button class="button button--small" [disabled]="submitted" (click)="onClickBack()">
          Back</button>&nbsp;
        <button class="button button--small" [disabled]="submitted" (click)="onClickNext()">
          Next</button>&nbsp;
        <button class="button button--small" [disabled]="submitted" (click)="submit($event)" type="submit">
          Save & Exit
        </button>
      </div>
    </div>
  </div>

</div>